var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTooltip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:none;stroke:#none;stroke-width:3.5;stroke-linecap:round;stroke-linejoin:round;}\n\t.st2{fill:none;stroke:#none;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10,17c-3.9,0-7-3.1-7-7c0-3.9,3.1-7,7-7s7,3.1,7,7C17,13.9,13.9,17,10,17z M10,4c-3.3,0-6,2.7-6,6s2.7,6,6,6 s6-2.7,6-6S13.3,4,10,4z M10,7.5c-0.2,0-0.4-0.1-0.5-0.2C9.4,7.2,9.3,7,9.3,6.8c0-0.2,0.1-0.4,0.2-0.5C9.6,6.2,9.8,6.1,10,6.1 c0.2,0,0.4,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.2,0.5c0,0.2-0.1,0.4-0.2,0.5C10.4,7.4,10.2,7.5,10,7.5z M9.4,8.4h1.1v5.1H9.4V8.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltip);
export default __webpack_public_path__ + "static/media/tooltip.18fafc14da82cbf478571de9163f4877.svg";
export { ForwardRef as ReactComponent };